import { render, staticRenderFns } from "./wysiwyg-editor.vue?vue&type=template&id=1dc1b346"
import script from "./wysiwyg-editor.vue?vue&type=script&lang=ts"
export * from "./wysiwyg-editor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports